
import {GET_CURRENT_WEATHER_STARTED} from "../../reducers/weatherReducer";

export const getCurrentWeatherStarted = () =>{
    return {
        type: GET_CURRENT_WEATHER_STARTED,
        payload: {}
    }
}